// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#welcome-animation .dropdown-menu {\n  transform: unset!important;\n}\n#welcome-animation .dropdown-wrapper {\n  position: fixed;\n}\n", ""]);
// Exports
module.exports = exports;
